import 'css-chunk:src/components/form-fields/radio-component/radio-component.module.scss';export default {
  "radio-component": "radio-component_radio-component__OSSFG",
  "column": "radio-component_column__IstUd",
  "row": "radio-component_row__leDXR",
  "icon": "radio-component_icon__08UTb",
  "container": "radio-component_container__DZMCP",
  "label": "radio-component_label__gY-f7",
  "small": "radio-component_small__qgPl2",
  "selected-option-container": "radio-component_selected-option-container__gD-KN",
  "traditional-container": "radio-component_traditional-container__XtNGA",
  "radio-custom": "radio-component_radio-custom__s0ifO",
  "radio-custom-label": "radio-component_radio-custom-label__QxRMW",
  "radio-selected": "radio-component_radio-selected__iW-oQ",
  "radio-unselected": "radio-component_radio-unselected__3Z-Tm",
  "radio-custom-selected": "radio-component_radio-custom-selected__rExoR"
};